<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-select',
  mixins: [abstractField],
  computed: {
    items() {
      let values = this.schema.values;
      return values;
    }
  },
  methods: {
    onChange($event) {
      this.schema.onChange(this.model, this.schema, $event);
      this.value = $event;
    }
  },
  render() {
    const legoMultiDropdown = resolveComponent('lego-multi-dropdown');
    const legoDropdown = resolveComponent('lego-dropdown');
    return this.schema.multi
      ? h(legoMultiDropdown, {
          selectAll: true,
          selectAllText: this.schema.selectAllText,
          id: this.schema.id,
          modelValue: this.value,
          items: this.items,
          disabled: this.schema.disabled,
          name: this.schema.inputName,
          class: this.schema.fieldClasses,
          width: this.schema.width,
          placeholder: this.schema.placeholder || 'Nothing selected',
          'onUpdate:modelValue': this.onChange
        })
      : h(legoDropdown, {
          id: this.schema.id,
          modelValue: this.value,
          items: this.items,
          disabled: this.schema.disabled,
          name: this.schema.inputName,
          class: this.schema.fieldClasses,
          width: this.schema.width,
          placeholder: this.schema.placeholder || 'Nothing selected',
          'onUpdate:modelValue': this.onChange
        });
  }
};
</script>

<style lang="scss">
.c-form-group {
  .lego-dropdown {
    + .lego-button {
      margin-left: 8px;
    }
  }
}
</style>
